module.exports = __webpack_public_path__ + "static/media/templateone11.d442b767.png";